import React, { useState } from 'react'
import AdminAppBar from '../../adminComponents/AdminAppBar'
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom'
import Gift from './Gift'
import SpinWheelForm from './SpinWheelForm'
import SpinWheelService from '../../Services/SpinWheelService'
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from 'react-toastify'


const SpinWheelCreation = () => {
  const [spObj, setSpObj]= useState();
  const [gifts, setgifts]= useState();

    const navigate = useNavigate()
    const location = useLocation()

console.log(gifts)
const userObj = JSON.parse(localStorage.getItem("userData"));
const userUid = userObj?.user?.uid;


const createdUserDocId= userUid;
const modifiedUserDocId = userUid
    const handleCreate =async()=>{
      if(!gifts || !spObj){
        showErrorToast("All Fields are mandatory")
        return false;
      }

      try{
  const response = await SpinWheelService.createSpinwheel(spObj,gifts,createdUserDocId, modifiedUserDocId)
  console.log(response.data)
navigate(-1, {state: {message: "Spin Wheel created succussfully"}})
}catch(error){
  showErrorToast(error.response.data)
  console.log(error.response.data)
}
    }
    const handleBack=()=>{
navigate(-1)
    }
const GiftData =(gifts)=>{
  setgifts(gifts)
}
const spData =(sp)=>{
  setSpObj(sp)
}
  return (
    <div className=' bg-appGrayBackground pb-10 '>
      <AdminAppBar/>
<ToastContainer/>
      <div className="pt-24 px-20 xl:px-6 relative flex justify-between gap-5">
        <div className="flex gap-6">
          <svg
            onClick={handleBack}
            className="cursor-pointer"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
          <div>
            <h1 className="text-4xl font-semibold whitespace-nowrap">
              New Spin wheel
            </h1>
          </div>
        </div>
        <div>
          <button
            onClick={handleCreate}
            className=" whitespace-nowrap bg-customGreen rounded-lg p-1 px-5 w-32 text-lg text-white h-10 text-center"
          >
            Create
          </button>
        </div>






      </div>
      <div className='mt-5 mx-10 flex gap-10 '>
        <div className='w-8/12 bg-white rounded-lg px-5 py-5 ' >

        <Gift giftsDetail={GiftData} />
        </div>
        <div className='w-4/12 bg-white rounded-lg px-5'>
            <SpinWheelForm spDetail={spData} />
        </div>
    </div>
    </div>
  )
}

export default SpinWheelCreation
